module.exports = __webpack_public_path__ + "assets/img/slogan-c5fab560.png";